export default __webpack_public_path__ + "static/media/348.689cc4c6.jpg";